import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Common, Widget } from '@stockbit/ui';

import { Pagination } from 'antd';
import If from 'global/ErrorHandlers/If';
import { useRouter } from 'next/router';
import { TableContainer, Td, Th } from './styled';
import valuationWidgetSlice, { effects, selectors } from '../slice';
import SymbolLink from '../../SymbolLink';

const { Text } = Common;
const { Table, Select } = Widget;

const ListTableScreener = () => {
  const dispatch = useDispatch();

  const router = useRouter();
  const isInChartbitPage = router.pathname.includes('chartbit');

  const state = useSelector(selectors);
  const { getLoadPresetScreener, postScreenerListResult, currentScreenerData } =
    state;

  const { data: dataLoadScreener, isLoading: isLoadingScreener } =
    getLoadPresetScreener;

  const { isLoading: isLoadingNextPageScreener } = postScreenerListResult;

  const { page, isDataLoaded, shouldUpdate } = currentScreenerData;

  const [currentResultIndex, setCurrentResultIndex] = useState(0);

  const handleOnSelectFilter = (columnId) => {
    const findIndexSelectedColumn = dataLoadScreener.columns.findIndex(
      (loadScreener) => loadScreener.id === columnId,
    );

    // set selected index column
    setCurrentResultIndex(findIndexSelectedColumn);
  };

  const handleClick = useCallback(
    (symbol) => {
      const urlSuffix = isInChartbitPage ? '/chartbit' : '';
      router.push(`/symbol/${symbol}${urlSuffix}`, undefined, {
        shallow: isInChartbitPage,
      });
    },
    [dataLoadScreener],
  );

  const columns = [
    {
      title: <Th>Symbol</Th>,
      dataIndex: 'symbol',
      key: 'symbol',
    },
    {
      title: (
        <Select
          width="100%"
          border="none"
          value={
            dataLoadScreener.columns &&
            dataLoadScreener.columns.length > 0 &&
            dataLoadScreener.columns[currentResultIndex].id
          }
          style={{ height: '30px' }}
          onSelect={handleOnSelectFilter}
          getPopupContainer={(trigger) => trigger.parentElement}
        >
          {dataLoadScreener.columns &&
            dataLoadScreener.columns.length > 0 &&
            dataLoadScreener.columns.map((screener) => (
              <Select.Option value={screener.id}>
                <Text
                  align="right"
                  height="inherit"
                  size="11.5px"
                  family="bold"
                >
                  {screener.name}
                </Text>
              </Select.Option>
            ))}
        </Select>
      ),
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const dataSource =
    dataLoadScreener.calcs &&
    dataLoadScreener.calcs.length > 0 &&
    dataLoadScreener.calcs.map((screener) => ({
      key: `${screener.company.id}`,
      symbol: (
        <SymbolLink
          symbol={screener.company.symbol}
          isPreventDefault
          onClick={() => handleClick(screener.company.symbol)}
        >
          <Td family="bold">{screener.company.symbol}</Td>
        </SymbolLink>
      ),
      value: (
        <Td align="right">
          <span style={{ cursor: 'text' }}>
            {screener.results[currentResultIndex].display}
          </span>
        </Td>
      ),
    }));

  const handleTableChange = (page) => {
    const { universe } = dataLoadScreener;
    const filters = JSON.stringify(dataLoadScreener.rules);
    const ordercol = 2; // di legacy hardcode 2
    const ordertype = dataLoadScreener.sort || 'ASC';

    const { screenerid } = dataLoadScreener;

    const name = dataLoadScreener.screen_name;
    const description = dataLoadScreener.screen_desc;

    const requestBody = {
      universe,
      filters,
      screenerid: String(screenerid),
      name,
      description,
      page,
      ordercol,
      ordertype,
    };

    // export interface IScreenerSaveOrRunPayload {
    //   universe: IUniverseSaveOrRunPayload | string;
    //   filters?: IFiltersSaveOrRunPayload[] | string | null;
    //   page: number;
    //   ordercol: number;
    //   ordertype: string;
    //   sequence?: number | string | string[];
    //   save?: number;
    //   name: string;
    //   description: string;
    // }
    // TODO: Remove this lines after layout feature has been implemented
    dispatch(
      // @ts-ignore
      valuationWidgetSlice.actions.setCurrentScreenerData({
        shouldUpdate: false,
      }),
    );
    // dispatch nextpage
    dispatch(effects.postScreenerListResult(requestBody));
  };

  // TODO: Remove this lines after layout feature has been implemented
  const handlePageChange = (currPage) => {
    dispatch(
      // @ts-ignore
      valuationWidgetSlice.actions.setCurrentScreenerData({
        page: currPage,
        shouldUpdate: true,
      }),
    );
  };

  const { curpage, perpage, totalrows } = dataLoadScreener;

  // TODO: Remove this lines after layout feature has been implemented
  useEffect(() => {
    if (isDataLoaded && shouldUpdate) {
      handleTableChange(page);
    }
  }, [isDataLoaded, page, shouldUpdate]);

  return (
    <TableContainer>
      <Table
        loading={isLoadingScreener || isLoadingNextPageScreener}
        dataSource={dataSource}
        columns={columns}
        pagination={{ position: ['bottomLeft'], pageSize: perpage }}
        onChange={handlePageChange}
      />
      <If condition={totalrows > 25}>
        <Pagination
          onChange={handlePageChange}
          total={totalrows}
          current={curpage}
          pageSize={perpage}
          hideOnSinglePage
          showQuickJumper={false}
          showSizeChanger={false}
        />
      </If>
    </TableContainer>
  );
};

export default ListTableScreener;
